// The session notice (formerly the 22 px status bar; simplified 15 Oct 2026): the frame no longer carries a bar at the bottom. How the
// session was established, the last sign-in and "Every action is audited" moved to the account menu; Accessibility and Help moved there
// too; the warehouse facts live in the Intelligence row's sources popover and the Trust Centre. What stays on the surface is the one
// thing that needs the person: from five minutes before the idle sign-out, a quiet notice at the bottom of the content column with the
// countdown and "Stay signed in" (WP-SEC-UI's IdleDialog takes over at two minutes). The report-an-issue host stays mounted here, so
// the account menu's "Report an issue" keeps working. WP-SHELL.
import { Clock } from "lucide-react";
import { markSessionActivity, useAuth } from "@ncp/api-client";
import { useTranslation } from "@ncp/i18n";
import { countdownText, IDLE_WARNING_MS, useSessionCountdown } from "../session";
import { ReportIssueHost } from "./HelpMenu";

/** The notice shows from this long before the idle sign-out until the idle dialog takes over. */
export const IDLE_NOTICE_MS = 5 * 60_000;

export function StatusBar() {
  const { t } = useTranslation();
  const { managed } = useAuth();
  const { idleLeftMs } = useSessionCountdown();
  const soon = managed && idleLeftMs !== null && idleLeftMs > IDLE_WARNING_MS && idleLeftMs <= IDLE_NOTICE_MS;
  return (
    <>
      {soon ? (
        <div className="es-idle" role="status" aria-live="off" data-econic-status="" data-session-warning="idle-soon">
          <Clock aria-hidden />
          <span>{t("assistant:econic.shell.status.idle")} <bdi dir="ltr">{countdownText(idleLeftMs)}</bdi></span>
          <button type="button" onClick={() => markSessionActivity()}>{t("assistant:econic.shell.status.stay")}</button>
        </div>
      ) : null}
      <ReportIssueHost />
    </>
  );
}
